import React from "react";

import { Box, Text } from "@seneca/senekit";

type Props = {
  children?: React.ReactNode;
};

export default function ErrorMessage({ children }: Props) {
  return (
    <Box
      marginBottom="large"
      marginTop="small"
      visibility={children ? "visible" : "hidden"}
    >
      <Text size="small" tone="error">
        {children || "error placeholder"}
      </Text>
    </Box>
  );
}
